import React, { useEffect, useState, useMemo } from "react";
import "./CatchDispositionList.scss";
import {
  Box,
  Grid,
  FormControl,
  FormGroup,
  Button,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";

const CatchDispositionList = (props) => {
  const [buttonLabel, setButtonLabel] = useState("");
  const { combinedSum, sales } = props;
  // * Added useMemo to cache the assignment and avoid the ui from re-renders
  const filteredList = useMemo(
    () =>
      combinedSum.filter(
        (item) => item.original_available !== item.original_sold
      ),
    [combinedSum]
  );

  useEffect(() => {
    sales.length === Object.entries(filteredList).length
      ? setButtonLabel("Deselect All")
      : setButtonLabel("Select All");
  }, [filteredList, sales]);

  if (filteredList.length === 0) {
    return (
      <div>
        <Box mt={0} width="100%" align="center">
          <h2 className="sectionTitle center">Species Catch</h2>
          <div>{"No fish available."}</div>
        </Box>
      </div>
    );
  }

  const handleClick = (event) => {
    let sales = [];
    if (buttonLabel === "Select All") {
      filteredList.forEach((species) => {
        species.sold = species.available;
        species.available = 0;
        return;
      });
    } else if (buttonLabel === "Deselect All") {
      filteredList.forEach((species) => {
        species.sold = 0;
        species.available = species.original_available;
        return;
      });
    }

    if (props.sales.length === 0) {
      sales = filteredList.map((data) => {
        return data.species;
      });
    } else if (
      props.sales.length > 0 &&
      props.sales.length < Object.entries(filteredList).length
    ) {
      let pendingSpecies = filteredList.filter(function (data) {
        return !props.sales.includes(data.species);
      });
      const newList = pendingSpecies.map((data) => {
        return data.species;
      });
      sales = [...props.sales, ...newList];
    }
    props.handleCatchDispositionChange(event, sales);
  };

  return (
    <div className="CatchDisposition" data-testid="CatchDisposition">
      <Box mt={0} width="100%" align="center">
        <h2 className="sectionTitle center">Species Catch</h2>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <Grid item xs={12} md="auto">
            <FormControl component="fieldset">
              <FormGroup>
                <Button
                  variant="contained"
                  onClick={(event) => handleClick(event)}
                  endIcon={<DoneAllIcon />}
                >
                  {buttonLabel}
                </Button>
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} md="auto">
            <FormControl
              style={{ width: "250px" }}
              className="catch-disposition-dropdown"
            >
              <ToggleButtonGroup
                id="catch_auto_complete"
                name={"species"}
                orientation={"vertical"}
                onChange={props.handleCatchDispositionChange}
                value={sales}
              >
                {filteredList.map(function (d, idx) {
                  return (
                    <ToggleButton
                      style={{ margin: "5px" }}
                      key={idx + d.species}
                      id={d.species + idx}
                      value={d.species}
                    >
                      Species code: {d.species} <br />
                      Species Name: {d.species_label} <br />
                      Qty. available: {d.original_available} <br />
                      Quantity sold: {d.total_sold}
                    </ToggleButton>
                  );
                })}
              </ToggleButtonGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default CatchDispositionList;
